module.exports = __webpack_public_path__ + "e4cc8ee95310da18a215c6348962a1eb.pdf";